import NoWebgl from "./NoWebgl";

export default NoWebgl;
